import React, { Component } from "react";
import PropType from "prop-types";

class SubscribeCard extends Component {
  render() {
    const { url, iconSrc, altText } = this.props;

    return (
      <div className="col-auto pt-20 pb-20">
        <a href={url} target="_blank" rel="noopener noreferrer" title={altText}>
          <img height="30" src={iconSrc} alt="" role="presentation" />
        </a>
      </div>
    );
  }
}

SubscribeCard.propTypes = {
  url: PropType.string.isRequired,
  iconSrc: PropType.string.isRequired,
  altText: PropType.string.isRequired
};

export default SubscribeCard;
